import { Selection as SelectionType } from '../../../../../../types/Survey/Element'
import { Selection as SelectionAnswerType } from '../../../../../../types/Survey/Answer/Element'
import { Props } from '../types'
import Core from '../Core'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import List from './List'

const Selection: React.FC<Props<SelectionType, SelectionAnswerType>> = ({ element, answerElement, updateElement }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const toggle = (uuid: string) => () => {
    const isSelected = answerElement.selectedOptions.includes(uuid)
    if (isSelected) {
      updateElement({ ...answerElement, selectedOptions: answerElement.selectedOptions.filter((sO) => sO !== uuid) })
    } else {
      if (element.isMultipleChoice) {
        if (!element.maxMultipleChoice || answerElement.selectedOptions.length + 1 <= element.maxMultipleChoice) {
          updateElement({ ...answerElement, selectedOptions: [...answerElement.selectedOptions, uuid] })
        }
      } else {
        updateElement({ ...answerElement, selectedOptions: [uuid] })
      }
    }
  }

  const isSelected = (uuid: string) => answerElement.selectedOptions.includes(uuid)

  return (
    <div>
      <Core element={element} answerElement={answerElement} />
      <List options={element.options.map((o) => ({ ...o, selected: isSelected(o.uuid) }))} toggle={toggle} />
      {element.isMultipleChoice && !!element.maxMultipleChoice && (
        <div className="text-sm text-gray mt-2">
          {element.forceMultipleChoiceMax
            ? t.survey.answer.selection.maxMultipleChoiceForce(element.maxMultipleChoice)
            : t.survey.answer.selection.maxMultipleChoice(element.maxMultipleChoice)}
        </div>
      )}
    </div>
  )
}

export default Selection
